import * as React from 'react';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = props => /*#__PURE__*/_jsx("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  className: "svg-icon " + (props.className || ''),
  children: /*#__PURE__*/_jsx("path", {
    d: "M10 8.586 2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414z"
  })
});
const Memo = /*#__PURE__*/memo(SvgClose);
export default Memo;